<template>
  <div>
    <div>
      <cart-side />
    </div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search :words="searchKeyWords" @search="search" @searchList="searchList" />
      </div>
    </div>
    <div>
      <app-nav />
    </div>
    <div v-if="isShowModel" class="model-QRCode">
      <div class="close-model"><span @click="closeModel">X</span></div>
      <p style="margin-top:60px;">请使用微信扫描二维码 </p>
      <img :src="imgurl" alt="付款码">
    </div>
    <div class="all-order">
      <div class="all-order-header">
        <b-container>
          <b-row class="time-select">
            <b-col cols="1">全部订单：</b-col>
            <b-col cols="6">
              <span class="select-time">
                <date-picker v-model="startTime" language="zh-cn" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
              </span>
              <span style="margin:0 20px;">至</span>
              <span class="select-time">
                <date-picker v-model="endTime" language="zh-cn" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
              </span>
            </b-col>
            <b-col><b-button class="search-btn" :disabled="time" @click="searchByTime">按日期查询</b-button></b-col>
          </b-row>
          <b-row class="word-select">
            <b-col cols="7"><b-form-input v-model="searchText" placeholder="通用名/送货单位/订单号" /></b-col>
            <b-col><b-button class="search-btn" :disabled="word" @click="searchByWord">按内容查询</b-button></b-col>
          </b-row>
        </b-container>
      </div>
      <order-info :orders="orderList" @showModal="showCode" />
      <div>
        <page-info :page-info="pageInfo" @searchFirst="changePage" />
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import datepicker from 'vue-date'
import OrderInfo from './OrderInfo'
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import PageInfo from '@/components/Pagination.vue'
import nav from '@/components/Nav.vue'
import CartSide from '../item/CartSide'
import { OrderService } from '@/service/OrderService'
export default {
  components: {
    'cart-side': CartSide, 'app-nav': nav, 'page-info': PageInfo, 'date-picker': datepicker,
    search, topbar, 'app-footer': footer, 'order-info': OrderInfo
  },
  data () {
    return {
      searchKeyWords: [],
      startTime: '',
      endTime: '',
      searchText: '',
      orderList: [],
      pageInfo: { count: '', index: 1, pages: '', size: 5 },
      isShowModel: false,
      imgurl: ''
    }
  },
  computed: {
    time: function () {
      let result = true
      if (this.startTime && this.endTime && this.startTime < this.endTime) {
        result = false
      }
      return result
    },
    word: function () {
      let result = true
      if (this.searchText) {
        result = false
      }
      return result
    }
  },
  created () {
    this.loadOrders()
  },
  methods: {
    loadOrders () {
      const startTime = this.startTime === '' ? '' : this.startTime + ' 00:00:00'
      const endTime = this.endTime === '' ? '' : this.endTime + ' 23:59:59'
      const searchInfos = {
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        search: this.searchText,
        status: -1,
        orderBy: 'createTime desc',
        startTimeStr: startTime,
        endTimeStr: endTime
      }
      const order = new OrderService(this.$axios)
      order.loadAllOrders(searchInfos).then((orderInfo) => {
        ({ orders: this.orderList, pageInfo: this.pageInfo } = orderInfo)
      })
    },
    searchByTime () {
      this.searchText = ''
      this.pageInfo.index = 1
      this.loadOrders()
    },
    searchByWord () {
      this.startTime = ''
      this.endTime = ''
      this.pageInfo.index = 1
      this.loadOrders()
    },
    search () {
    },
    showCode (url) {
      this.isShowModel = true
      this.imgurl = process.env.VUE_APP_API + 'hy-sb-order/' + url
      this.setTime()
    },
    closeModel () {
      this.isShowModel = false
      clearInterval(this.limitTime)
      this.loadOrders()
    },
    setTime () {
      clearInterval(this.limitTime)
      let time = 60
      this.limitTime = setInterval(() => {
        if (time <= 0) {
          this.closeModel()
        } else {
          time--
        }
      }, 1000)
    },
    searchList () {
    },
    changePage (pageInfo) {
      this.pageInfo = pageInfo
      this.loadOrders()
    }
  }
}
</script>
<style>
  .all-order {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .all-order .all-order-header {
    height: 70px;
    margin-top:10px;
  }
  .all-order-header .col,
  .all-order-header .col-1,
  .all-order-header .col-6,
  .all-order-header .col-7{
    padding: 0;
    text-align: left;
    vertical-align: 0;
  }
  .time-select input,
  .all-order .search-btn {
    width: 220px;
    height: 30px;
    display: inline-block;
    padding: 0;
  }
  .date-list li .message span {
    left: 50% !important;
  }
   .date-list li .message .bg {
    left: 0 !important;
  }
  .time-select input {
    text-indent: 4px;
  }
  .word-select input {
    width: 494px;
    height: 30px;
    display: inline-block;
    padding: 0;
    margin-left: 100px;
    text-align: center;
  }
  .all-order .search-btn {
    background-color: #d8d8d8;
    color: #000;
    border-color: #ced4da;
    vertical-align: 10px;
  }
  .time-select span.select-time {
    display:inline-block;
    width: 220px;
    background-color: #fff;

  }
  .time-select .form-control:focus {
    outline: 0;
  }
  .model-QRCode {
    position:fixed;
    width: 300px;
    height: 300px;
    top:50%;
    margin-top: -150px;
    margin-left: -150px;
    left:50%;
    z-index: 100;
    background-color: #fff;
    text-align: center;
  }
  .close-model {position:relative;}
  .close-model span {
    position: absolute;
    right: 10px;
    top:10px;
    border: 1px solid #ccc;
    width: 40px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    border-radius: 50%;
    cursor:pointer;
  }
  .model-QRCode img {
    width: 200px;
    height: 200px;
  }
</style>
